import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import BookshopProject from '../components/bookshop/project.vue';
import LibraryProject from '../components/library/project.vue';
import { ViewerContext } from '../types/viewer_context';

@Component({ components: { BookshopProject, LibraryProject } })
export default class Project extends Vue {
  @Getter public viewerContext?: ViewerContext;
}
